import { enableProdMode, Injectable } from '@angular/core';
import { AuthClientConfig, AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../../environments/environment';
import { provideGlobalGridOptions } from 'ag-grid-enterprise';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  constructor(
    private readonly auth: AuthService,
    private readonly authConfig: AuthClientConfig
  ) {}

  initializeApp(): Promise<void> {
    if (!environment.isLocal) {
      enableProdMode();
    }

    provideGlobalGridOptions({ theme: 'legacy' });
    return new Promise((resolve) => {
      this.authConfig.set({
        clientId: environment.auth0Config.clientId,
        domain: environment.auth0Config.domain,
        authorizationParams: {
          audience: environment.auth0Config.audience,
          // eslint-disable-next-line camelcase
          redirect_uri: window.location.origin + '/callback',
        },
        httpInterceptor: environment.auth0Config.httpInterceptor,
      });
      resolve();
    });
  }
}
